import { Renderer, ElementRef } from '@angular/core';

export abstract class PopoverEditable {

	protected constructor(protected renderer: Renderer, protected element: ElementRef) { }

	saving: boolean;

	errorMessage: string;

	abstract get inputElementRef(): any;

	abstract get popoverElementRef(): any;

	abstract get name(): string;

	abstract onCancel(): void;

	public get title() {
		if (this.name)
			return "Edit " + this.name;
		return "";
	}

	get required(): boolean {
		return this.element.nativeElement.getAttribute('required') != null;
	}

	public onShown() {
		setTimeout(() => this.renderer.invokeElementMethod(this.inputElementRef.nativeElement, 'focus', []));
	}

	public onHidden() {
		this.errorMessage = "";
	}

	public show() {
		this.popoverElementRef.show();
	}

	public hide() {

		if (this.popoverElementRef.isOpen) {
			this.popoverElementRef.hide();
		}
	}

	public static isNumber(val) { return typeof val === 'number'; }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/popover-editable.ts